import React from "react"
import PropTypes from "prop-types"
import SideNav from './SideNav'
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'

class TopNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen,
    })
  }

  render() {
    const navClass = this.props.variant === 'dash'
      ? 'lex-top-nav lex-top-nav--dash'
      : 'lex-top-nav';

    return(
      <header className={navClass}>
        <a href="/home" className="lex-top-nav__logo" aria-label="Lexody home" />
        <button
          type="button"
          className="lex-top-nav__menu-btn"
          onClick={() => this.toggleMenu()}
          aria-label="Open menu"
          aria-expanded={this.state.menuOpen}
        >
          <Icon
            name="bars"
            size={this.props.variant === 'dash' ? 20 : 22}
            color={semantic.primary.surface.default}
          />
        </button>
        {this.state.menuOpen &&
          <SideNav
            currentUserSlug={this.props.currentUserSlug}
            currentUserAvatar={this.props.currentUserAvatar}
            currentUserName={this.props.currentUserName}
            currentUserStats={this.props.currentUserStats}
            premiumUser={this.props.premiumUser}
            accentImages={this.props.accentImages}
            logout={this.props.logout}
            toggleMenu={this.toggleMenu}
          />}
      </header>
    )
  }
}

TopNav.propTypes = {
  currentUserSlug: PropTypes.string,
  currentUserAvatar: PropTypes.string,
  currentUserName: PropTypes.string,
  currentUserStats: PropTypes.string,
  premiumUser: PropTypes.bool,
  accentImages: PropTypes.object,
  logout: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'dash']),
}

TopNav.defaultProps = {
  variant: 'dash',
}

export default TopNav
